<template>
  <div class="flex flex-wrap items-center justify-between pb-4 py-1">
    <!-- Modal Content -->
    <div class="flex-grow p-6 space-y-8 text-sm text-gray-700 overflow-y-auto">
      <!-- Section 1: General Info -->
      <div v-if="inventoryItem.item_type === 1">
        <h3 class="text-lg font-semibold text-gray-800 border-b pb-2">
          Category: Pharmaceutical
        </h3>
        <div class="grid grid-cols-3 gap-y-4 gap-x-8 mt-4">
          <div>
            <strong>Code:</strong><br />
            {{ inventoryItem.code }}
          </div>
          <div>
            <strong>Medicine Type:</strong><br />
            {{ inventoryItem.drug_category?.name }}
          </div>
          <div>
            <strong>Generic Name:</strong> <br />
            {{ inventoryItem.generic_name }}
          </div>
          <div>
            <strong>Brand Name:</strong><br />
            {{ inventoryItem.trade_name }}
          </div>
          <div>
            <strong>Storage Conditions:</strong>
            <br />
            {{ inventoryItem.storage_conditions }}
          </div>
          <div>
            <strong>Formulation Type:</strong>
            <br />
            {{ inventoryItem.drug_dosage_form?.name }}
          </div>
          <div>
            <strong>Dosage Strength:</strong>
            <br />
            {{ inventoryItem.strength }}
          </div>
          <div>
            <strong>Unit of Measure:</strong><br />
            {{ inventoryItem.drug_strength_unit?.name }}
          </div>
          <div>
            <strong>Requires Prescription:</strong><br />
            {{ inventoryItem.prescription_required == 1 ? "Yes" : "No" }}
          </div>
          <div>
            <strong>Requires Doctor Approval:</strong><br />
            <span
              :class="inventoryItem.approval_required ? 'text-red-600 font-semibold' : 'text-green-700'"
            >
              {{ inventoryItem.approval_required ? "Yes — consultation only" : "No" }}
            </span>
          </div>
          <!-- <div>
            <strong>Location In The Hospital:</strong><br />
            {{ inventoryItem.location }}
          </div> -->
          <div>
            <strong>National Drug Code:</strong><br />
            {{ inventoryItem.ndc_code }}
          </div>
          <div>
            <strong>Manufacturer:</strong> <br />{{
              inventoryItem.manufacturer
            }}
          </div>
        </div>
      </div>

      <div v-if="inventoryItem.item_type === 2">
        <h3 class="text-lg font-semibold text-gray-800 border-b pb-2">
          Category: Non-Pharmaceutical
        </h3>
        <div class="grid grid-cols-2 gap-y-4 gap-x-8 mt-4">
          <div>
            <strong>Item Code:</strong><br />
            {{ inventoryItem.code }}
          </div>
          <div>
            <strong>Item Name:</strong> br {{ inventoryItem.trade_name }}
          </div>
          <div>
            <strong>Storage Condition:</strong>
            <br />
            {{ inventoryItem.storage_conditions }}
          </div>
          <div>
            <strong>Location In The Hospital:</strong>
            {{ inventoryItem.location }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InventoryItemDetailsTab",
  props: {
    inventoryItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>
